define('vspot-angular/resources/waitlist-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // See user-resource for general documentation
        return $resource('/api/waitlists/:controller/:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {

                create_activity_waitlist: {
                    method: 'POST',
                    params: {
                        controller: 'create_activity_waitlist'
                    }
                },
                create_event_waitlist: {
                    method: 'POST',
                    params: {
                        controller: 'create_event_waitlist'
                    }
                },
                create_job_waitlist: {
                    method: 'POST',
                    params: {
                        controller: 'create_job_waitlist'
                    }
                },

                delete_activity_waitlist: {
                    method: 'POST',
                    params: {
                        controller: 'delete_activity_waitlist'
                    }
                },
                delete_event_waitlist: {
                    method: 'POST',
                    params: {
                        controller: 'delete_event_waitlist'
                    }
                },
                delete_job_waitlist: {
                    method: 'POST',
                    params: {
                        controller: 'delete_job_waitlist'
                    }
                },
                my_waitlists: {
                    method: 'POST',
                    params: {
                        controller: 'my_waitlists'
                    }
                }
            }
        );
    }];
});


